import {
  Autocomplete,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import IMDashboardSearch from "../../../components/Dashboard/IMDashboardSearch";
import TipeIncident from "../../../components/Dashboard/TipeIncident";
import KategoriIncident from "../../../components/Dashboard/KategoriIncident";
import StatusIncident from "../../../components/Dashboard/StatusIncident";
import SnackbarCustom from "../../../components/SnackbarCustom";
import ApiService from "../../../services/ApiService";

const IMDashboard = ({ dataRegion, dataTahun }) => {
  // States
  const [dataLokasi, setDataLokasi] = useState([]);
  const [region, setRegion] = React.useState("");
  const [lokasi, setLokasi] = useState(null);
  const [selected, setSelected] = useState({
    regionId: 0,
    lokasiId: 0,
    tahun: 0,
  });
  const [cartData, setCartData] = useState({
    kategoriIncident: [],
    tipeIncident: [],
    statusIncident: [],
  });
  const [snackbar, setSnackbar] = useState({
    isOpen: false,
    message: "",
  });

  // Void functions
  const getDataLokasi = (id) => {
    ApiService.getMsLokasi(id).then((res) => {
      var result = res.data.payload;
      setDataLokasi(result);
    });
  };

  const handleRegion = (e, value) => {
    setLokasi(null);
    if (!value) {
      setDataLokasi([]);
      setSelected((prev) => ({ ...prev, regionId: 0, lokasiId: 0 }));
      return;
    }

    getDataLokasi(value.id);
    setSelected((prev) => ({ ...prev, regionId: value.id, lokasiId: 0 }));
  };

  const handleLokasi = (e, value) => {
    if (!value) {
      setLokasi(null);
      setSelected((prev) => ({ ...prev, lokasiId: 0 }));
      return;
    }

    setSelected((prev) => ({ ...prev, lokasiId: value.id }));
    setLokasi(value);
  };

  const handleTahun = (event) => {
    if (!event.target.value) {
      setSelected((prev) => ({ ...prev, tahun: null }));
      return;
    }

    setSelected((prev) => ({ ...prev, tahun: event.target.value }));
  };

  const getCartData = async () => {
    const { regionId, locationId, tahun } = selected;
    try {
      const data = await Promise.all([
        // KATEGORI INCIDENT
        ApiService.postCartbyKategoryInsiden({
          regionId,
          locationId,
          year: tahun,
        }).then((res) => res.data.payload),
        // TIPE INCIDENT
        ApiService.postCartbyTipeInsiden({
          regionId,
          locationId,
          year: tahun,
        }).then((res) => res.data.payload),
        // STATUS LKP
        ApiService.postCartbyStatusLkp({
          regionId,
          locationId,
          year: tahun,
        }).then((res) => res.data.payload),
      ]);

      setCartData({
        kategoriIncident: data[0],
        tipeIncident: data[1],
        statusIncident: data[2],
      });
    } catch (error) {
      setSnackbar({
        isOpen: true,
        message: "Error fetching cart data",
      });
    }
  };

  // UseEffects
  useEffect(() => {
    getCartData();
  }, [selected]);

  return (
    <>
      <Container maxWidth>
        <Grid container spacing={2}>
          <Grid item xl={3} lg={3} sm={6} xs={12}>
            <KategoriIncident
              data={cartData.kategoriIncident}
              year={selected.tahun}
            />
          </Grid>
          <Grid item xl={3} lg={3} sm={6} xs={12}>
            <TipeIncident data={cartData.tipeIncident} year={selected.tahun} />
          </Grid>
          <Grid item xl={3} lg={3} sm={6} xs={12}>
            <StatusIncident data={cartData.statusIncident} />
          </Grid>
          <Grid item xl={3} lg={3} sm={6} xs={12}>
            <Stack spacing={4.5}>
              <FormControl fullWidth style={{ backgroundColor: "white" }}>
                <Autocomplete
                  name="idRegional"
                  onChange={(e, value) => handleRegion(e, value)}
                  required
                  getOptionLabel={(option) => option.name}
                  options={dataRegion}
                  renderInput={(params) => (
                    <TextField {...params} label="Regional/Anak Perusahaan" />
                  )}
                  getOptionSelected={(option, value) =>
                    option.name === value.name
                  }
                />
              </FormControl>
              <FormControl fullWidth style={{ backgroundColor: "white" }}>
                <Autocomplete
                  name="idLokasi"
                  onChange={(e, value) => handleLokasi(e, value)}
                  required
                  value={lokasi}
                  disabled={dataLokasi.length === 0}
                  getOptionLabel={(option) => option.name}
                  options={dataLokasi}
                  renderInput={(params) => (
                    <TextField {...params} label="Lokasi" />
                  )}
                  getOptionSelected={(option, value) =>
                    option.name === value.name
                  }
                />
              </FormControl>
              <FormControl fullWidth style={{ backgroundColor: "white" }}>
                <InputLabel id="lblSelectTahun">Tahun</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="SelectTahun"
                  value={selected.tahun || ""}
                  label="Tahun"
                  onChange={handleTahun}
                >
                  {dataTahun.map((data) => (
                    <MenuItem id={data.id} key={data.id} value={data.id}>
                      {data.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>
          </Grid>
        </Grid>
      </Container>
      <SnackbarCustom
        duration={3000}
        type={"error"}
        open={snackbar.isOpen}
        onClose={() => setSnackbar({ isOpen: false, message: "" })}
        message={snackbar.message}
      />
    </>
  );
};

export default IMDashboard;
